import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.invoices
)

export const selectInvoices = createSelector(
    baseSelector,
    (state) => state.invoices
)

export const selectTotalPages = createSelector(
    baseSelector,
    (state) => state.totalPages
)

export const selectInvoicesLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)

export const selectInvoicesFirstLoad = createSelector(
    baseSelector,
    (state) => state.isFirstLoad
)

export const selectCurrentPage = createSelector(
    baseSelector,
    (state) => state.page
)